// BASE APPS
const CLIENT_PORTAL = '';

const appRoutes = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET: '/reset',

  // BASE APPS
  CLIENT_PORTAL,

  // CLIENT PORTAL ROUTES
  DASHBOARD: `${CLIENT_PORTAL}/`,
  GROUPS: `${CLIENT_PORTAL}/groups`,
  API_TOKENS: `${CLIENT_PORTAL}/api-tokens`,

  CLIENTS: `${CLIENT_PORTAL}/clients`,
  CUSTOMERS: `${CLIENT_PORTAL}/customers`,
  CONTACTS: `${CLIENT_PORTAL}/people`,
  INTERNAL_USERS: `${CLIENT_PORTAL}/internal-users`,
  CONTACTS_LIST: `${CLIENT_PORTAL}/contacts`,
  CONTENT: `${CLIENT_PORTAL}/content`,
  REQUESTS: `${CLIENT_PORTAL}/requests`,
  PROJECTS: `${CLIENT_PORTAL}/projects`,
  INBOX: `${CLIENT_PORTAL}/inbox`,
  TERMS: `${CLIENT_PORTAL}/terms`,
  PRIVACY: `${CLIENT_PORTAL}/privacy`,
  TASKS: `${CLIENT_PORTAL}/tasks`,

  TIME_LOG_REPORT: `${CLIENT_PORTAL}/timelog-report`,
  REPORT: `${CLIENT_PORTAL}/report`,
  REPORT_USER_PERFORMANCE: `${CLIENT_PORTAL}/report/user-performance`,

  PENDING_REPLIES: `${CLIENT_PORTAL}/pending-replies`,

  FILE_VIEWER: `${CLIENT_PORTAL}/file-viewer`,

  HOW_TO: `${CLIENT_PORTAL}/how-to`,

  TEAM_ACTIVITY: `${CLIENT_PORTAL}/team-activity`,
  TEAM_ACTIVITY_TASKS: `${CLIENT_PORTAL}/team-activity-tasks`,
};

export default appRoutes;
